export default {
  props: {
    readonly: Boolean
  }
}
